import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwardsComponent } from 'src/app/view/awards/awards.component';
import { InterComponent } from 'src/app/view/awards/inter/inter.component';
import { NobilityComponent } from 'src/app/view/awards/nobility/nobility.component';
import { StarComponent } from 'src/app/view/awards/star/star.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    AwardsComponent,
    InterComponent,
    StarComponent,
    NobilityComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'',component:AwardsComponent,children:[
        {path:'inter',component:InterComponent},
        {path:'star',component:StarComponent},
        {path:'notability',component:NobilityComponent}
      ]}
    ])
  ]
})
export class AwardModule { }
